var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import utils from 'web3-utils';
import { FctParam, FctTradingGraphProps, FctTupleArray } from './generics/FctParams';
import { BigNumber, utils as ethUtils } from 'ethers';
import BigDecimal from 'bignumber.js';
import { utils as etherUtils } from 'ethers';
export var GAS_LIMIT_OVERHEAD = '27500';
export var MIN_GAS_LIMIT = '21000';
export var generateRandomUint64Number = function () { return BigNumber.from(ethUtils.randomBytes(8)).toString(); };
export var toCapitalize = function (name) { return name.charAt(0).toUpperCase() + name.slice(1); };
export var getParamIsNotDefined = function (name) { return "param ".concat(name, " is not defined."); };
export var validate = function (params) {
    for (var key in params) {
        var paramKey = key;
        if (!params[paramKey].value && params[paramKey].required) {
            throw new Error(getParamIsNotDefined(String(paramKey)));
        }
    }
};
export var paramKeyToName = function (_a) {
    var key = _a.key;
    return key.split('.').slice(-1)[0];
};
export var getMethodParams = function (_a) {
    var params = _a.params;
    var methodParams = [];
    for (var key in params) {
        var paramKey = key;
        var param = params[paramKey];
        if (param.virtual)
            continue;
        if (param instanceof FctTupleArray) {
            methodParams.push({
                name: paramKey.replace("_tuple[]", ''),
                type: param.fctType,
                value: param.getFctParams(),
                customType: true,
                messageType: param.getMessageType(),
                innerIndex: param.innerIndex,
                virtual: param.virtual,
                estimatedValue: param.estimatedValue,
                isTupleArray: true,
                tupleType: param.tupleType,
            });
            continue;
        }
        if (param instanceof FctParam && !(param instanceof FctTradingGraphProps)) {
            var value = param.get();
            // if (param.hashed && param.fctType === 'bytes32' && typeof param.value === 'string' && !ethUtils.isBytesLike(param.value)) {
            //   value = ethUtils.id(param.value)
            // }
            // if (param.hashed && param.fctType === 'bytes' && typeof param.value === 'string' && !ethUtils.isBytesLike(param.value)) {
            //   const coder = ethUtils.defaultAbiCoder
            //   value = coder.encode(['string'], [param.value])
            // }
            methodParams.push({
                name: paramKey,
                type: param.fctType,
                value: value,
                customType: false,
                messageType: param.getMessageType(),
                innerIndex: param.innerIndex,
                virtual: param.virtual,
                estimatedValue: param.estimatedValue,
            });
        }
        else {
            var nestedParams = param;
            //methodParams.push(getMethodParams({ params: nestedParams }))
            var values = getMethodParams({ params: nestedParams });
            var isNotVirtual = values.find(function (value) { return !value.virtual; });
            if (!isNotVirtual)
                continue;
            var _b = __read(paramKey.split('_'), 2), name_1 = _b[0], type = _b[1];
            methodParams.push({
                name: name_1,
                type: type === 'tuple' ? "tuple" : "tuple[]",
                value: values,
                customType: true,
                innerIndex: 0,
            });
        }
    }
    return methodParams;
};
export var getContractInterface = function (_a) {
    var method = _a.method, params = _a.params;
    if (!method.length && !params.length)
        return '';
    var args = '';
    var setInterfaceArgs = function (params, args) {
        for (var paramKey in params) {
            if (params[paramKey])
                if (params[paramKey].isTupleArray) {
                    var type = params[paramKey].tupleType;
                    args += "".concat(type, " ").concat(params[paramKey].name, ",");
                    continue;
                }
            if (!params[paramKey].customType) {
                var type = params[paramKey].type;
                args += "".concat(type, " ").concat(params[paramKey].name, ",");
            }
            else if (params[paramKey]) {
                var withTuple = setInterfaceArgs(params[paramKey].value, '(');
                var parsed = withTuple.replace(/,\s*$/, '');
                parsed += ") ".concat(params[paramKey].name, ",");
                args += parsed;
            }
        }
        return args;
    };
    var newArgs = setInterfaceArgs(params, args);
    return "".concat(method, "(").concat(newArgs.replace(/,$/, ''), ")");
};
export var getContractInterfaceReturns = function (_a) {
    var e_1, _b, e_2, _c;
    var params = _a.params;
    if (!params || !Object.keys(params).length)
        return "";
    var returns = "(";
    try {
        for (var _d = __values(Object.keys(params)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var paramKey = _e.value;
            var param = params[paramKey];
            if (param && param instanceof FctTupleArray) {
                returns += param.tupleInterface;
                continue;
            }
            if (paramKey.includes("tuple")) {
                var tuple = "(";
                try {
                    for (var _f = (e_2 = void 0, __values(Object.keys(params[paramKey]))), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var tupleParamKey = _g.value;
                        var tupleParam = params[paramKey];
                        tuple += "".concat(tupleParam[tupleParamKey].innerType, " ").concat(tupleParamKey, ",");
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                if (paramKey.includes("tuple[]")) {
                    tuple += ")[]";
                }
                else {
                    tuple += ")";
                }
                returns += tuple;
                continue;
            }
            if (!(params[paramKey] instanceof FctParam))
                return "";
            var paramType = params[paramKey].innerType;
            if (paramType.includes("[]")) {
                return "returns (".concat(paramType, " ").concat(paramKey, ")");
            }
            returns += "".concat(paramType, " ").concat(paramKey, ",");
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return "returns ".concat(returns.replace(/,$/, ''), ")");
};
export var getMethodInterface = function (_a) {
    var method = _a.method, params = _a.params;
    if (method === 'magic')
        return 'magic';
    if (!method.length && !params.length)
        return '';
    var args = '';
    var setInterfaceArgs = function (params, args) {
        for (var paramKey in params) {
            if (params[paramKey].isTupleArray) {
                var type = params[paramKey].tupleType;
                args += "".concat(type, " ").concat(params[paramKey].name, ",");
                continue;
            }
            if (!params[paramKey].customType) {
                var type = params[paramKey].hashed && params[paramKey].type === 'string' ? 'bytes32' : params[paramKey].type;
                args += "".concat(type, ",");
            }
            else if (params[paramKey]) {
                var type = params[paramKey].type;
                var withTuple = setInterfaceArgs(params[paramKey].value, '(');
                var parsed = withTuple.replace(/,\s*$/, '');
                parsed += type.includes('{}') ? ")[]," : "),";
                args += parsed;
            }
        }
        return args;
    };
    var newArgs = setInterfaceArgs(params, args);
    return "".concat(method, "(").concat(newArgs.replace(/,$/, ''), ")");
};
export var getMethodDescription = function (_a) {
    var methodInterface = _a.methodInterface, type = _a.type, protocol = _a.protocol;
    return "".concat(protocol, " ").concat(type, ": ").concat(methodInterface).trim();
};
export var injectProtocol = function (_a) {
    var name = _a.name, plugins = _a.plugins;
    for (var key in plugins) {
        if (typeof plugins[key] === 'object') {
            return injectProtocol({ name: name, plugins: plugins[key] });
        }
        if (typeof plugins[key] === 'function') {
            // eslint-disable-next-line @typescript-eslint/ban-types
            var plugin = plugins[key];
            plugin.prototype.protocol = name;
        }
    }
};
var FctParamsFactory = /** @class */ (function () {
    function FctParamsFactory() {
    }
    FctParamsFactory.prototype.create = function (schema) {
        return schema;
    };
    return FctParamsFactory;
}());
export { FctParamsFactory };
export var fctParamsFactory = new FctParamsFactory();
export var currencyToWei = function (value, decimals) {
    var _a;
    try {
        if ((value === null || value === void 0 ? void 0 : value.toString()) && decimals) {
            var val = value.toString();
            var _b = __read(val.split('.'), 2), whole = _b[0], fraction = _b[1];
            if (!whole)
                whole = '0';
            if (!fraction)
                fraction = '0';
            while (fraction.length < decimals)
                fraction += '0';
            var toBN = utils.toBN;
            var wei = toBN(whole)
                .mul(toBN(+"1e".concat(decimals)))
                .add(toBN(fraction));
            return (_a = toBN(wei === null || wei === void 0 ? void 0 : wei.toString())) === null || _a === void 0 ? void 0 : _a.toString();
        }
        return utils.toWei((value === null || value === void 0 ? void 0 : value.toString()) || '0', 'ether');
    }
    catch (e) {
        console.error(e);
        return '0';
    }
};
export var weiToCurrency = function (value, decimals) {
    if (decimals === void 0) { decimals = 18; }
    if (!value)
        return undefined;
    BigDecimal.config({
        DECIMAL_PLACES: decimals,
        ROUNDING_MODE: BigDecimal.ROUND_FLOOR,
    });
    try {
        var ethValue = new BigDecimal(value.toString())
            .div(new BigDecimal("1".concat('0'.repeat(decimals))))
            .multipliedBy(new BigDecimal('1'));
        var decimalsPlaces = ethValue.decimalPlaces();
        if (decimalsPlaces && decimalsPlaces > 6 && ethValue.lt(new BigDecimal('0.000001'))) {
            // remove scientific notation eg:(1+18) for small numbers
            return ethValue.toFormat(decimals);
        }
        return ethValue.toString();
    }
    catch (e) {
        console.error({ ethValueError: e });
        return '0';
    }
};
function stringToBytes32(input) {
    if (input.length > 31) {
        throw new Error("String \"".concat(input, "\" is too long to be converted to bytes32 (max 31 bytes)."));
    }
    return etherUtils.formatBytes32String(input);
}
export var toBytes32 = function (value) {
    if (!value)
        return value;
    if (etherUtils.isHexString(value, 32)) {
        return value;
    }
    return stringToBytes32(value);
};
